import { useState } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const CranesPage = () => {
  const [activeTab, setActiveTab] = useState<'light' | 'heavy'>('heavy');

  const heavyCranes = [
    {
      id: 1,
      name: 'رافعة هيدروليكية 300 طن',
      capacity: '300 طن',
      height: '100 متر',
      reach: '80 متر',
      description: 'رافعة ضخمة للمشاريع الكبرى مثل ناطحات السحاب والمنشآت الصناعية الضخمة',
      image: 'massive yellow hydraulic crane 300 ton capacity at mega construction site, giant industrial crane lifting heavy steel structure, skyscraper construction, professional photography',
      features: ['قوة رفع استثنائية', 'تقنية متطورة', 'أمان عالي', 'كفاءة عالية'],
      uses: ['ناطحات السحاب', 'الجسور الكبرى', 'المنشآت النفطية', 'المشاريع الحكومية الضخمة'],
    },
    {
      id: 2,
      name: 'رافعة هيدروليكية 250 طن',
      capacity: '250 طن',
      height: '90 متر',
      reach: '70 متر',
      description: 'رافعة قوية مناسبة للمشاريع الصناعية والتجارية الكبيرة',
      image: 'powerful yellow hydraulic crane 250 ton capacity working at large industrial site, heavy duty crane with extended boom, professional construction photography',
      features: ['استقرار فائق', 'مدى وصول ممتاز', 'تحكم دقيق', 'صيانة منتظمة'],
      uses: ['المجمعات التجارية الكبرى', 'المصانع الضخمة', 'الأبراج العالية', 'البنية التحتية'],
    },
    {
      id: 3,
      name: 'رافعة هيدروليكية 200 طن',
      capacity: '200 طن',
      height: '80 متر',
      reach: '65 متر',
      description: 'رافعة متعددة الاستخدامات للمشاريع المتوسطة والكبيرة',
      image: 'versatile yellow hydraulic crane 200 ton capacity at construction project, mobile crane lifting materials, professional equipment photography',
      features: ['مرونة عالية', 'سرعة في التنفيذ', 'تقنية حديثة', 'أداء موثوق'],
      uses: ['المباني الإدارية', 'المستشفيات', 'الفنادق الكبرى', 'المراكز التجارية'],
    },
    {
      id: 4,
      name: 'رافعة هيدروليكية 160 طن',
      capacity: '160 طن',
      height: '70 متر',
      reach: '60 متر',
      description: 'رافعة قوية للمشاريع التجارية والسكنية الكبيرة',
      image: 'strong yellow hydraulic crane 160 ton capacity at commercial construction site, reliable crane equipment, professional photography',
      features: ['قدرة رفع عالية', 'سهولة التشغيل', 'أمان معزز', 'كفاءة في الأداء'],
      uses: ['الأبراج السكنية', 'المولات التجارية', 'المستودعات الكبيرة', 'المشاريع الحكومية'],
    },
  ];

  const lightCranes = [
    {
      id: 5,
      name: 'رافعة هيدروليكية 19 طن',
      capacity: '19 طن',
      height: '30 متر',
      reach: '25 متر',
      description: 'رافعة مثالية للمشاريع السكنية والتجارية المتوسطة',
      image: 'compact yellow hydraulic crane 19 ton capacity at residential construction site, mobile crane with extended boom, professional photography',
      features: ['سهلة المناورة', 'اقتصادية', 'سريعة التنقل', 'مناسبة للمساحات الضيقة'],
      uses: ['الفلل والقصور', 'المباني السكنية', 'المحلات التجارية', 'أعمال الصيانة'],
    },
    {
      id: 6,
      name: 'رافعة هيدروليكية 15 طن',
      capacity: '15 طن',
      height: '28 متر',
      reach: '22 متر',
      description: 'رافعة متوسطة للمشاريع السكنية والتجارية الصغيرة',
      image: 'medium yellow hydraulic crane 15 ton capacity working at small construction site, versatile mobile crane, professional equipment photography',
      features: ['مرونة عالية', 'تكلفة مناسبة', 'سهولة التشغيل', 'متوفرة بكثرة'],
      uses: ['المنازل السكنية', 'الفلل الصغيرة', 'المحلات', 'أعمال التركيب'],
    },
    {
      id: 7,
      name: 'رافعة هيدروليكية 10 طن',
      capacity: '10 طن',
      height: '25 متر',
      reach: '20 متر',
      description: 'رافعة خفيفة للمشاريع الصغيرة وأعمال الصيانة',
      image: 'small yellow hydraulic crane 10 ton capacity at residential site, compact mobile crane, easy maneuvering, professional photography',
      features: ['خفيفة الوزن', 'سريعة الحركة', 'اقتصادية جداً', 'مثالية للمساحات الضيقة'],
      uses: ['المنازل الصغيرة', 'أعمال الصيانة', 'التركيبات الخفيفة', 'المشاريع السريعة'],
    },
    {
      id: 8,
      name: 'رافعة هيدروليكية 7 طن',
      capacity: '7 طن',
      height: '22 متر',
      reach: '18 متر',
      description: 'رافعة صغيرة للأعمال الخفيفة والصيانة السريعة',
      image: 'mini yellow hydraulic crane 7 ton capacity at small construction site, lightweight mobile crane, professional equipment photography',
      features: ['صغيرة الحجم', 'سهلة النقل', 'تكلفة منخفضة', 'مناسبة للأعمال السريعة'],
      uses: ['أعمال الصيانة السريعة', 'التركيبات الصغيرة', 'المشاريع المنزلية', 'الأعمال الطارئة'],
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden mt-20">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/f653e849687b7a43196618e8a5b7f76b.jpg"
            alt="الرافعات الهيدروليكية"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-primary/75"></div>
        </div>

        <div className="relative z-10 container mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-6xl md:text-7xl font-black text-white mb-6">الرافعات الهيدروليكية</h1>
            <p className="text-2xl text-accent font-bold">أسطول ضخم من الرافعات بقدرات من 7 إلى 300 طن</p>
          </motion.div>
        </div>
      </section>

      {/* Tab Switcher */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="flex justify-center mb-12">
            <div className="bg-white rounded-full p-1 shadow-lg inline-flex">
              <button
                onClick={() => setActiveTab('heavy')}
                className={`px-8 py-3 rounded-full font-bold text-base transition-all whitespace-nowrap ${
                  activeTab === 'heavy'
                    ? 'bg-accent text-primary'
                    : 'text-gray-600 hover:text-primary'
                }`}
              >
                الرافعات الثقيلة
              </button>
              <button
                onClick={() => setActiveTab('light')}
                className={`px-8 py-3 rounded-full font-bold text-base transition-all whitespace-nowrap ${
                  activeTab === 'light'
                    ? 'bg-accent text-primary'
                    : 'text-gray-600 hover:text-primary'
                }`}
              >
                الرافعات الخفيفة
              </button>
            </div>
          </div>

          {/* Heavy Cranes Section */}
          {activeTab === 'heavy' && (
            <div>
              <div className="text-center mb-12">
                <div className="inline-flex items-center gap-3 bg-red-100 text-red-600 px-6 py-3 rounded-full mb-4">
                  <i className="ri-fire-fill text-2xl"></i>
                  <span className="font-black text-lg">160 - 300 طن</span>
                </div>
                <h2 className="text-5xl md:text-6xl font-black text-primary mb-4">الرافعات الثقيلة</h2>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                  رافعات ضخمة بقدرات استثنائية للمشاريع الكبرى والبنية التحتية
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {heavyCranes.map((crane, index) => (
                  <motion.div
                    key={crane.id}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: index * 0.1 }}
                    className="bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all group"
                  >
                    <div className="relative h-72 overflow-hidden">
                      <img
                        src={`https://readdy.ai/api/search-image?query=$%7Bcrane.image%7D&width=800&height=600&seq=heavy-crane-${crane.id}&orientation=landscape`}
                        alt={crane.name}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-primary/90 to-transparent"></div>
                      <div className="absolute top-6 right-6">
                        <span className="bg-red-500 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg">
                          ثقيلة
                        </span>
                      </div>
                      <div className="absolute bottom-6 left-6 right-6">
                        <h3 className="text-3xl font-black text-white mb-2">{crane.name}</h3>
                        <p className="text-accent font-bold text-xl">{crane.capacity}</p>
                      </div>
                    </div>

                    <div className="p-8">
                      <p className="text-gray-700 text-lg mb-6 leading-relaxed">{crane.description}</p>

                      <div className="grid grid-cols-2 gap-4 mb-6">
                        <div className="flex items-center gap-3">
                          <div className="w-12 h-12 flex items-center justify-center bg-accent/10 rounded-xl">
                            <i className="ri-arrow-up-line text-2xl text-accent"></i>
                          </div>
                          <div>
                            <p className="text-sm text-gray-500">ارتفاع الرفع</p>
                            <p className="font-black text-primary">{crane.height}</p>
                          </div>
                        </div>
                        
                        <div className="flex items-center gap-3">
                          <div className="w-12 h-12 flex items-center justify-center bg-accent/10 rounded-xl">
                            <i className="ri-arrow-right-line text-2xl text-accent"></i>
                          </div>
                          <div>
                            <p className="text-sm text-gray-500">مدى الوصول</p>
                            <p className="font-black text-primary">{crane.reach}</p>
                          </div>
                        </div>
                      </div>

                      <div className="mb-6">
                        <h4 className="text-lg font-bold text-primary mb-3 flex items-center gap-2">
                          <i className="ri-checkbox-circle-fill text-accent"></i>
                          <span>المميزات</span>
                        </h4>
                        <div className="grid grid-cols-2 gap-2">
                          {crane.features.map((feature, idx) => (
                            <div key={idx} className="flex items-center gap-2">
                              <i className="ri-arrow-left-s-fill text-accent"></i>
                              <span className="text-sm text-gray-700">{feature}</span>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="mb-6">
                        <h4 className="text-lg font-bold text-primary mb-3 flex items-center gap-2">
                          <i className="ri-building-fill text-accent"></i>
                          <span>الاستخدامات</span>
                        </h4>
                        <div className="flex flex-wrap gap-2">
                          {crane.uses.map((use, idx) => (
                            <span
                              key={idx}
                              className="bg-accent/10 text-primary px-3 py-1 rounded-lg text-sm font-semibold"
                            >
                              {use}
                            </span>
                          ))}
                        </div>
                      </div>

                      <div className="flex items-center gap-3 p-4 bg-green-50 rounded-xl">
                        <div className="w-12 h-12 flex items-center justify-center bg-green-500 rounded-lg">
                          <i className="ri-shield-check-fill text-2xl text-white"></i>
                        </div>
                        <div>
                          <p className="text-green-800 font-bold">معتمدة من TÜV</p>
                          <p className="text-green-600 text-sm">فحص فني دوري</p>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          )}

          {/* Light Cranes Section */}
          {activeTab === 'light' && (
            <div>
              <div className="text-center mb-12">
                <div className="inline-flex items-center gap-3 bg-green-100 text-green-600 px-6 py-3 rounded-full mb-4">
                  <i className="ri-leaf-fill text-2xl"></i>
                  <span className="font-black text-lg">7 - 19 طن</span>
                </div>
                <h2 className="text-5xl md:text-6xl font-black text-primary mb-4">الرافعات الخفيفة</h2>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                  رافعات مرنة وسريعة للمشاريع السكنية والتجارية الصغيرة والمتوسطة
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {lightCranes.map((crane, index) => (
                  <motion.div
                    key={crane.id}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: index * 0.1 }}
                    className="bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all group"
                  >
                    <div className="relative h-72 overflow-hidden">
                      <img
                        src={`https://readdy.ai/api/search-image?query=$%7Bcrane.image%7D&width=800&height=600&seq=light-crane-${crane.id}&orientation=landscape`}
                        alt={crane.name}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-primary/90 to-transparent"></div>
                      <div className="absolute top-6 right-6">
                        <span className="bg-green-500 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg">
                          خفيفة
                        </span>
                      </div>
                      <div className="absolute bottom-6 left-6 right-6">
                        <h3 className="text-3xl font-black text-white mb-2">{crane.name}</h3>
                        <p className="text-accent font-bold text-xl">{crane.capacity}</p>
                      </div>
                    </div>

                    <div className="p-8">
                      <p className="text-gray-700 text-lg mb-6 leading-relaxed">{crane.description}</p>

                      <div className="grid grid-cols-2 gap-4 mb-6">
                        <div className="flex items-center gap-3">
                          <div className="w-12 h-12 flex items-center justify-center bg-accent/10 rounded-xl">
                            <i className="ri-arrow-up-line text-2xl text-accent"></i>
                          </div>
                          <div>
                            <p className="text-sm text-gray-500">ارتفاع الرفع</p>
                            <p className="font-black text-primary">{crane.height}</p>
                          </div>
                        </div>
                        
                        <div className="flex items-center gap-3">
                          <div className="w-12 h-12 flex items-center justify-center bg-accent/10 rounded-xl">
                            <i className="ri-arrow-right-line text-2xl text-accent"></i>
                          </div>
                          <div>
                            <p className="text-sm text-gray-500">مدى الوصول</p>
                            <p className="font-black text-primary">{crane.reach}</p>
                          </div>
                        </div>
                      </div>

                      <div className="mb-6">
                        <h4 className="text-lg font-bold text-primary mb-3 flex items-center gap-2">
                          <i className="ri-checkbox-circle-fill text-accent"></i>
                          <span>المميزات</span>
                        </h4>
                        <div className="grid grid-cols-2 gap-2">
                          {crane.features.map((feature, idx) => (
                            <div key={idx} className="flex items-center gap-2">
                              <i className="ri-arrow-left-s-fill text-accent"></i>
                              <span className="text-sm text-gray-700">{feature}</span>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="mb-6">
                        <h4 className="text-lg font-bold text-primary mb-3 flex items-center gap-2">
                          <i className="ri-building-fill text-accent"></i>
                          <span>الاستخدامات</span>
                        </h4>
                        <div className="flex flex-wrap gap-2">
                          {crane.uses.map((use, idx) => (
                            <span
                              key={idx}
                              className="bg-accent/10 text-primary px-3 py-1 rounded-lg text-sm font-semibold"
                            >
                              {use}
                            </span>
                          ))}
                        </div>
                      </div>

                      <div className="flex items-center gap-3 p-4 bg-green-50 rounded-xl">
                        <div className="w-12 h-12 flex items-center justify-center bg-green-500 rounded-lg">
                          <i className="ri-shield-check-fill text-2xl text-white"></i>
                        </div>
                        <div>
                          <p className="text-green-800 font-bold">معتمدة من TÜV</p>
                          <p className="text-green-600 text-sm">فحص فني دوري</p>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-5xl md:text-6xl font-black text-primary mb-6">
              احجز رافعتك الآن
            </h2>
            <p className="text-2xl text-gray-600 mb-12 max-w-3xl mx-auto">
              تواصل معنا للحصول على استشارة مجانية وعرض سعر مخصص
            </p>
            <div className="flex flex-wrap justify-center gap-6">
              <a
                href="tel:920000000"
                className="bg-accent hover:bg-accent-dark text-primary px-12 py-5 rounded-xl font-black text-xl transition-all shadow-2xl hover:shadow-accent/50 hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
              >
                <i className="ri-phone-fill text-2xl"></i>
                <span>اتصل بنا: 920000000</span>
              </a>
              <a
                href="https://wa.me/966500000000"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-primary hover:bg-primary-dark text-white px-12 py-5 rounded-xl font-bold text-xl transition-all shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
              >
                <i className="ri-whatsapp-fill text-2xl"></i>
                <span>واتساب</span>
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CranesPage;